import InfoCard from "@/components/common/infoCard/infoCard";
import EmptySection from "@/components/serviceFlow/clientDetails/emptySection";
import ExpandableSection from "@/components/serviceFlow/clientDetails/expandableSection";
import { AuthenticatedStripeProvider } from "@/config/authenticatedStripe";
import { CardsStack } from "./cardsStack";

interface WalletCardsSectionProps {
  title?: string;
  description?: string;
  clientId?: string;
  expanded?: boolean;
  onlyDefaultCard?: boolean;
}

export default function WalletCardsSection({
  title,
  description,
  clientId,
  expanded,
  onlyDefaultCard = false,
}: WalletCardsSectionProps) {
  return (
    <AuthenticatedStripeProvider>
      <InfoCard>
        <ExpandableSection title={title ?? "Credit Cards"} expanded={expanded}>
          <CardsStack
            clientId={clientId}
            description={description}
            onlyDefaultCard={onlyDefaultCard}
            noCardInfo={
              <EmptySection>
                No cards yet. Please add the first card.
              </EmptySection>
            }
            noDefaultCardInfo={
              <EmptySection>
                No default card yet. Please add a default card.
              </EmptySection>
            }
          />
        </ExpandableSection>
      </InfoCard>
    </AuthenticatedStripeProvider>
  );
}
